import './Chip.css';

import { ChipRemoveEvent, Chip as PrimeChip } from 'primereact/chip';
import clsx from 'clsx';
import { StaticControlItem } from '../../../../../../../types/types';

interface ChipProps {
  value: string;
  options: StaticControlItem[];
  onRemove: (e: ChipRemoveEvent) => boolean;
  hasOverflow?: boolean;
}

const Chip = ({ value, options, onRemove, hasOverflow }: ChipProps) => {
  if (!value) return null;

  const label = options.find((option) => option.value === value)?.label;

  return (
    <PrimeChip
      className={clsx(
        'multi-select-chip',
        hasOverflow && 'multi-select-chip-has-scroll'
      )}
      label={label}
      removable
      onRemove={onRemove}
    />
  );
};

export default Chip;
